import React, { FC } from 'react';
import cx from 'classnames';
import { PropsWithClassName } from '@/types/common';
import Spinner from './images/spinner.svg';
import * as styles from './Loading.module.scss';

const Loading: FC<PropsWithClassName> = ({ className }) => (
  <Spinner className={cx(styles.main, className)} />
);

export default Loading;
